import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            内容导航
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Explore by topic
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            按分类浏览平台内容，快速找到您需要的信息和教程。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-background-100 transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}